module.exports = __webpack_public_path__ + "img/home-prize-1.9b807db8.png";